import { GridValidRowModel } from '@mui/x-data-grid';
import { AclEntriesCommonTooltip } from 'common/components/sharedCustomComponents/AclEntriesCommonTooltip/AclEntriesCommonTooltip';
import { ActionDefinition, ColumnDefinition, ColumnType, Operations } from 'common/types/TypeDefs';


export const getActionDefinitions = (
    getProductPackageUrlCallBack: (id: string) => string,
    shouldDisableLicenseButtonCallback: (row?: GridValidRowModel | undefined) => boolean,
    getLicenseUrlCallBack: (id: string, row?: GridValidRowModel | undefined) => string,
    shouldDisableButtons: boolean,
    tenantRequiresLicense: boolean
) => [
    { action: Operations.OpenLicense, disabled: shouldDisableLicenseButtonCallback, urlToOpen: getLicenseUrlCallBack, visible: () => {return tenantRequiresLicense;} },
    {
        action: Operations.OpenProductPackage,
        disabled: false,
        urlToOpen: getProductPackageUrlCallBack
    },
    { action: Operations.Edit, disabled: shouldDisableButtons },
    { action: Operations.Delete, disabled: shouldDisableButtons }
] as ActionDefinition[];

export const getColumnDefinitions = (tenantRequiresLicense: boolean) => { 
    let columns: ColumnDefinition[] = [
        { columnId: 'packageName', columnName: 'Package Name', columnType: ColumnType.First, copy: false, size: 0.9 },
        { columnId: 'conditionsToDisplay', columnName: 'ACL Conditions', columnType: ColumnType.Tooltip, copy: false, size: 0.9 },
    ];

    if (tenantRequiresLicense) {
        columns.push(
            { columnId: 'licenseBillingRecord', columnName: 'License', columnType: ColumnType.Tooltip, copy: false, size: 0.9 },
            { columnId: 'startDate', columnName: 'Start Date', columnType: ColumnType.Tooltip, copy: false, size: 0.9 },
            { columnId: 'endDate', columnName: 'End Date', columnType: ColumnType.Tooltip, copy: false, size: 0.9 },
            {
                columnId: 'status',
                columnName: 'Status',
                columnType: ColumnType.Chip,
                copy: false,
                sortable: false,
                size: 99,
                toolTip: AclEntriesCommonTooltip
            },
        );
    }

    columns.push({ columnId: 'actions', columnName: 'Actions', columnType: ColumnType.Action, copy: false, size: 0.9 });

    return columns;
};
